import { Component, Input, OnInit } from '@angular/core';
import { ComponentBase, DeploymentContext } from '@Common';
import { ReviewEditsService } from '../../services/review-edits.service.js';
import { Asset, Deal, Funding, UpdateStatus } from 'company-finder-common';

@Component({
	selector: 'approve-decline',
	templateUrl: './approve-decline.component.html',
	styleUrls: ['./approve-decline.component.scss'],
	standalone: false,
})
export class ApproveDeclineComponent extends ComponentBase implements OnInit {
	@Input()
	public propertyName: string;
	@Input()
	public deal: Deal;
	@Input()
	public funding: Funding;
	@Input()
	public asset: Asset;
	@Input()
	public includeInSummary = false;
	public statuses = UpdateStatus;

	public _status = UpdateStatus.Pending;

	public constructor(
		dc: DeploymentContext,
		protected _reviewEditsService: ReviewEditsService
	) {
		super(dc);
	}

	public get status(): UpdateStatus {
		if (this.propertyName) {
			return this._reviewEditsService.getPropertyStatus(
				this.propertyName
			);
		} // FUTURE - could we just us a model id here?
		else if (this.deal) {
			return this._reviewEditsService.getModelStatus(this.deal.dealId);
		} else if (this.funding) {
			return this._reviewEditsService.getModelStatus(
				this.funding.fundingId
			);
		} else if (this.asset) {
			return this._reviewEditsService.getModelStatus(this.asset.assetId);
		}
	}

	public get showButtons(): boolean {
		return !this.deal && !this.funding && !this.asset;
	}

	public approveDeal(deal: Deal): void {
		this._reviewEditsService.approveDeal(deal);
	}

	public approveFunding(funding: Funding): void {
		this._reviewEditsService.approveFunding(funding);
	}

	public approveProperty(): void {
		if (this.status !== UpdateStatus.Approved) {
			this._reviewEditsService.approveProperty(this.propertyName);
		} else {
			this._reviewEditsService.resetPropertyStatus(this.propertyName);
		}
	}

	public declineDeal(deal: Deal): void {
		this._reviewEditsService.declineDeal(deal);
	}

	public declineFunding(funding: Funding): void {
		this._reviewEditsService.declineFunding(funding);
	}

	public declineProperty(): void {
		if (this.status !== UpdateStatus.Declined) {
			this._reviewEditsService.declineProperty(this.propertyName);
		} else {
			this._reviewEditsService.resetPropertyStatus(this.propertyName);
		}
	}

	public get isInactive(): boolean {
		return !!this._reviewEditsService.currentEditItemProperty;
	}

	public ngOnInit(): void {
		this._reviewEditsService.register(this);
	}
}
